export { default as Widget } from './components/Widget'
export * from './store/actions/dispatcher'



// WEBPACK FOOTER //
// ./src/ChatWidget/index.js